import { useEffect } from 'react';

import env from '../../env';

const Trials = () => {
  useEffect(() => {
    window.location.href = env.SIGNUP_URL ?? 'https://podium.com/watch-demo/';
  }, []);

  return null;
};

export default Trials;
